var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("已退款金额："+_vm._s(_vm.refund.sum)+"元     待退款金额："+_vm._s(_vm.refund.wait)+"元")]),_vm._v(" "),_c('Table',{attrs:{"stripe":"","columns":_vm.columns,"data":_vm.refund.data}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56786821","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":true}!./src/pages/order/order_detail/refund-detail.vue
// module id = CaeX
// module chunks = 0